import createHistory from 'history/createBrowserHistory'
import thunkMiddleware from 'redux-thunk'
import { applyMiddleware, combineReducers, createStore } from 'redux'
import { routerMiddleware, routerReducer } from 'react-router-redux'
import { reducer as formReducer } from 'redux-form'
import { createLogger } from 'redux-logger'

import apiMiddleware from '../middleware/api'
import authReducer from '../reducers/auth'
import contractsReducer from '../reducers/contracts'
import customersReducer from '../reducers/customers'
import incidencesReducer from '../reducers/incidences'
import itemsReducer from '../reducers/items'
import MachinesReducer from '../reducers/machines'
import salesReducer from '../reducers/sales'
import usersReducer from '../reducers/users'
import remoteActionsReducer from '../reducers/remoteactions'
import updatesReducer from '../reducers/updates'
import shipmentsReducer from '../reducers/shipments'
import auditsReducer from '../reducers/audits'
import openingsReducer from '../reducers/openings'
import shiftsReducer from '../reducers/shifts'
import promoterSalesReducer from '../reducers/promotersales'
import matrixsReducer from '../reducers/matrixs'
import arqueosReducer from '../reducers/arqueos'
import promotersReducer from '../reducers/promoters'
import modulesReducer from '../reducers/modules'
import qrsReducer from '../reducers/qrs'
import withdrawalsReducer from '../reducers/withdrawals'
import replacementsReducer from '../reducers/replacements'
import faultsReducer from '../reducers/faults'
import supportticketsReducer from '../reducers/supporttickets'
import objectivesReducer from '../reducers/objectives'
import pdasReducer from '../reducers/pdas'
import operatorsReducer from '../reducers/operators'
import calendarsReducer from '../reducers/calendars'
import rulesReducer from '../reducers/rules'
import rentalsReducer from '../reducers/rentals'
import articlesReducer from '../reducers/articles'
import arqueosbaqueiraReducer from '../reducers/arqueosbaqueira'
import testsReducer from '../reducers/tests'
import gamesReducer from '../reducers/games'
import redeemCodesReducer from '../reducers/redeemcodes'
import emailTemplatesReducer from '../reducers/emailTemplates'
import partnersReducer from '../reducers/partners'
import discountCodesReducer from '../reducers/discountCodes'
import slasReducer from '../reducers/slas'
import licenseReducer from '../reducers/license'
import customerProfileReducer from '../reducers/customerProfile'
import bowlerReducer from '../reducers/bowler'
import proposalCatalogReducer from '../reducers/proposalCatalog'

import { AUTH_LOGOUT, AUTH_LOGIN_SUCCESS } from '../actions/auth'
import { tracker } from '../utils/tracker'

export const history = createHistory()

const myRouterMiddleware = routerMiddleware(history)
// create logger with a predicate so it can be turned off via env var
// by default it is enabled in development, but setting
// REACT_APP_DISABLE_LOGGER=true will suppress all logging.
const loggerMiddleware = createLogger({
  predicate: () => process.env.REACT_APP_DISABLE_LOGGER !== 'true',
});

const appReducer = combineReducers({
  auth: authReducer,
  contracts: contractsReducer,
  customers: customersReducer,
  incidences: incidencesReducer,
  items: itemsReducer,
  machines: MachinesReducer,
  sales: salesReducer,
  users: usersReducer,
  remoteactions: remoteActionsReducer,
  updates: updatesReducer,
  shipments: shipmentsReducer,
  audits: auditsReducer,
  shifts: shiftsReducer,
  promoterSales: promoterSalesReducer,
  matrixs: matrixsReducer,
  arqueos: arqueosReducer,
  promoters: promotersReducer,
  modules: modulesReducer,
  qrs: qrsReducer,
  withdrawals: withdrawalsReducer,
  replacements: replacementsReducer,
  faults: faultsReducer,
  supporttickets: supportticketsReducer,
  objectives: objectivesReducer,
  pdas: pdasReducer,
  openings: openingsReducer,
  operators: operatorsReducer,
  calendars: calendarsReducer,
  rules: rulesReducer,
  rentals: rentalsReducer,
  articles: articlesReducer,
  arqueosbaqueira: arqueosbaqueiraReducer,
  tests: testsReducer,
  games: gamesReducer,
  redeemCodes: redeemCodesReducer,
  emailTemplates: emailTemplatesReducer,
  partners: partnersReducer,
  discountCodes: discountCodesReducer,
  slas: slasReducer,
  license: licenseReducer,
  customerProfile: customerProfileReducer,
  bowler: bowlerReducer,
  proposalCatalog: proposalCatalogReducer,
  form: formReducer,
  router: routerReducer
})

const rootReducer = (state, action) => {
  if (action.type === AUTH_LOGOUT) {
    state = undefined
  }

  return appReducer(state, action)
};

// Tracking middleware — intercepts auth actions to maintain tracker identity.
// Must run AFTER the action is dispatched so the new auth state is available.
const trackingMiddleware = store => next => action => {
  const result = next(action)
  if (action.type === AUTH_LOGIN_SUCCESS && !action.fromStorage) {
    const { auth } = store.getState()
    tracker.setUser(auth)
    tracker.track('LOGIN', window.location.pathname, 'Login')
  } else if (action.type === AUTH_LOGIN_SUCCESS && action.fromStorage) {
    // Session restored from localStorage — set user identity but do NOT log as a login
    tracker.setUser(store.getState().auth)
  } else if (action.type === AUTH_LOGOUT) {
    tracker.track('LOGOUT', window.location.pathname, 'Logout')
    tracker.setUser(null)
  }
  return result
}

// assemble middleware stack; include logger only if it isn't disabled
const middleware = applyMiddleware(
  thunkMiddleware,
  apiMiddleware,
  myRouterMiddleware,
  trackingMiddleware,
  // loggerMiddleware will no-op if predicate returns false, but we also
  // avoid wiring it in production builds for performance
  ...(process.env.NODE_ENV !== 'production' ? [loggerMiddleware] : [])
)

export const store = createStore(rootReducer, middleware);
